<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask show-pricing-modal">
        <div class="modal-wrapper">
          <div
            class="modal-dialog"
            role="document"
          >
            <div class="modal-content">
              <button
                class="close-modal"
                @click="closeModal()"
              >
                <i
                  class="fa fa-times"
                  aria-hidden="true" 
                />
              </button>
              <div class="modal-body p-2">
                <div class="step">
                  <h3
                    class="h2 text-center text-uppercase font-weight-bold text-white"
                    :class="modal.step === 2 ? 'pt-0 mt-5 mb-5' : 'mb-1'"
                  >
                    Schedule a consultation
                  </h3>
                  <div
                    v-if="modal.success"
                    class="alert alert-success ml-1 mr-1 text-center"
                    role="alert"
                  >
                    Thanks, we will contact you soon.
                  </div>
                  <div v-else>
                    <div
                      class="modal-container step-1"
                      :class="modal.step === 0 ? 'show' : ''"
                    >
                      <div class="row mt-2">
                        <div class="col-12 col-md-6 flex-center form-1">
                          <div class="input-icon form-group mb-2 w-100">
                            <i class="icon-user form-icon" />
                            <span class="full-name">
                              <input
                                v-model="modal.fields['full-name']"
                                type="text"
                                name="full-name"
                                size="40"
                                class="form-control text form-control m-b"
                                placeholder="Full Name *"
                              >
                              <span
                                v-if="modal.error && modal.fields['full-name'] === null || modal.error && modal.fields['full-name'].length === 0"
                                role="alert"
                                class="wpcf7-not-valid-tip"
                              >The field is required.</span>
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-md-6 flex-center form-1">
                          <div class="input-icon form-group mb-2 w-100">
                            <i class="icon-link form-icon" />
                            <span class="full-name">
                              <input
                                v-model="defaultUrl"
                                type="text"
                                size="40"
                                class="form-control text form-control m-b"
                                placeholder="URL *"
                              >
                              <span
                                v-if="modal.error && defaultUrl === null || modal.error && defaultUrl.length === 0"
                                role="alert"
                                class="wpcf7-not-valid-tip"
                              >The field is required.</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="modal-container step-2"
                      :class="modal.step === 1 ? 'show' : ''"
                    >
                      <p class="text-center text-white">
                        Just one more thing...
                      </p>
                      <div class="row mt-2">
                        <div class="col-12 col-md-6 flex-center form-1">
                          <div class="input-icon form-group mb-2 w-100">
                            <i class="icon-question form-icon" />
                            <span class="full-name">
                              <input
                                v-model="modal.fields.interested_in"
                                type="hidden"
                                name="interested_in"
                                value=""
                              >
                              <input
                                v-model="modal.fields.phone"
                                type="number"
                                name="phone"
                                size="40"
                                class="form-control text form-control m-b"
                                placeholder="Phone number *"
                              >
                              <span
                                v-if="modal.error && modal.fields.phone === null || modal.error && modal.fields.phone.length === 0"
                                role="alert"
                                class="wpcf7-not-valid-tip"
                              >The field is required.</span>
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-md-6 flex-center form-1">
                          <div class="input-icon form-group mb-2 w-100">
                            <i class="icon-envelope form-icon" />
                            <span class="full-name">
                              <input
                                v-model="modal.fields.email"
                                type="email"
                                name="email"
                                size="40"
                                class="form-control text form-control m-b"
                                placeholder="Email *"
                              >
                              <span
                                v-if="modal.error && modal.fields.email === null || modal.error && modal.fields.email.length === 0 || modal.emailError && !modal.fields.email.includes('@')"
                                role="alert"
                                class="wpcf7-not-valid-tip"
                              >{{ modal.emailError ? 'Enter valid e-mail address' : 'The field is required.' }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      v-if="modal.step !== 2"
                      type="button"
                      class="next w-100 action-button btn btn-gradient-primary btn-oval btn-xxlg"
                      name="cf7mls_next"
                      @click="nextModalStep()"
                    >
                      {{ modal.step === 0 ? 'Next' : 'Submit form' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ZapierService from '@/services/ZapierService';

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      modal: {
        step: 0,
        fields: {
          _url: window.document.location.origin,
          source: "SEO Browser",
          interested_in: "Competition Analysis",
          'full-name': null,
          email: null,
          phone: null,
        },
        error: false,
        success: false,
        emailError: false,
        updatedUrl: null,
      },
    }
  },

  computed: {
    ...mapState('app', ['url']),
    
    defaultUrl: {
      // getter
      get: function () {
        if (!this.url) {
          return '';
        }

        return this.url;
      },
      // setter
      set: function (value) {
        console.log(value)
        this.modal.updatedUrl = value;
      }
    }
  },

  methods: {

    nextModalStep() {
      const _this = this;

      if (this.modal.step === 0 && this.modal.fields['full-name'] !== null && this.modal.fields.url !== null  && this.modal.fields['full-name'] !== '' && this.modal.fields.url !== '') {
        this.modal.step = 1;
        this.modal.error = false;
      } else if (this.modal.step === 1 && this.modal.fields.phone !== '' && this.modal.fields.phone !== null && this.modal.fields.email !== null && this.modal.fields.email !== '' && this.modal.fields.email.includes("@")) {
        this.modal.error = false;
        this.modal.fields.url = this.modal.updatedUrl ? this.modal.updatedUrl : this.url;
        ZapierService.sendEmail(_this.modal.fields);
        _this.modal.step = 0;
        this.modal.success = true;
      } else {
        this.modal.error = true;
        if (this.modal.fields.email !== null) {
          if (!this.modal.fields.email.includes("@")) {
            this.modal.emailError = true;
          }
        }
      }

    },

    closeModal() {
      this.$emit('on-close');

      this.modal.success = false,

      this.modal.step = 0;
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .15s linear;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  .action-button {
    height: 62px;
    padding: 0;
    position: relative;
    z-index: 100;
  }
  .modal-container {
    margin: 0 10px;
  }
  .step-1, .step-2 {
    opacity: 0;
    height: 0;
    position: absolute;
    transition: .5s;
    &.show {
      opacity: 1;
      height: auto;
      position: relative;
      transition: .5s;
    }
  }
  .close-modal {
    position: absolute;
    z-index: 100;
    color: #fff;
    border-radius: 50%;
    height: 4rem;
    width: 4rem;
    right: -16px;
    top: -14px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      color: #000;
      font-size: 20px;
    }
  }
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 602px;
    margin: 1.75rem auto;
  }
}
</style>
